import { CASEFORM_HOST } from 'utils/variables/constants'
import { MicroFrontend } from './microFrontend'

export const CaseformMicroFrontend = (): JSX.Element => {
  return <MicroFrontend host={CASEFORM_HOST} name="Caseform" />
}
